import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PeliculasService } from 'src/app/services/peliculas.service';
import { Movie } from 'src/app/interfaces/cartelera-response';

@Component({
  selector: 'app-buscar',
  templateUrl: './buscar.component.html',
  styleUrls: ['./buscar.component.css']
})
export class BuscarComponent implements OnInit {

  @Input() movies: Movie[] = [];

  public texto = '';

  constructor(  private activatedRoute: ActivatedRoute,
                private peliculaService: PeliculasService ) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe( params => {
      console.log(params.texto);
      this.texto = params.texto;
      // TODO llamar servicio
      this.peliculaService.buscarPelicula(params.texto).subscribe( movies => {
        this.movies = movies;
      });

    });
  }

}
